import { red } from '@ant-design/colors'
import styled from 'styled-components'

export const styleDeletedRows = <T extends React.ComponentType>(component: T) => styled(component)`
  && tbody > tr.deleted {
    td {
      background-color: ${red[1]} !important;
    }

    &:hover td {
      background-color: ${red[2]} !important;
      border-radius: 0 !important;
    }
  }
` as unknown as T